import * as Sentry from '@sentry/react';
import axios from 'axios';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app.component';
import { IEnvironment } from './shared';

const initializeApp = async () => {
    const { data: environment } = await axios.get<IEnvironment>(`/environment`);
    window.carity = {
        environment,
    };

    Sentry.init({
        enabled: environment.sentryEnabled,
        dsn: environment.sentryUrl,
        environment: environment.sentryEnvironment,
    });
};

const root = createRoot(document.getElementById('root') as HTMLElement);

initializeApp().then(() =>
    root.render(
        <React.StrictMode>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </React.StrictMode>,
    ),
);
